import { useRef, useState } from 'react';
export function useInterval(fn, interval) {
    var _a = useState(false), active = _a[0], setActive = _a[1];
    var intervalRef = useRef();
    var start = function () {
        setActive(true);
        intervalRef.current = window.setInterval(fn, interval);
    };
    var stop = function () {
        setActive(false);
        window.clearInterval(intervalRef.current);
    };
    var toggle = function () {
        if (active) {
            stop();
        }
        else {
            start();
        }
    };
    return { start: start, stop: stop, toggle: toggle, active: active };
}
